<template>
    <section class="footer">
        <div class="container">
            <div class="row">
                <div v-if="introduction" class="col-md-5 col-sm-10">
                    <h4>简介</h4>
                    <small class="color-eee">{{ introduction }}</small>
                </div>
                <div class="col-md-5 col-sm-7">
                    <h4>合作</h4>
                    <p class="color-eee">
                        电话：{{ phone }} <br>
                        <small v-if="mailbox">合作咨询邮箱：{{ mailbox }}</small>
                    </p>
                    <small v-if="address" class="color-eee">
                        地址：{{ address }}
                    </small>
                </div>
                <div class="col-md-2 col-sm-7">
                    <img v-if="erweima" :src="erweima" alt="logo" class="img-responsive footer-logo">
                </div>
            </div> <!-- /.row -->
        </div><!-- end container -->
        <section class="copyrights">
            <div class="container">
                <div class="row">
                    <div class="col-md-12 text-center">
                        &copy;{{ realmNameRegNum? realmNameRegNum : "京ICP备19022229号-1" }}
                    </div>
                </div> <!-- /.row -->
            </div><!-- /.container -->
        </section><!-- /.copyrights -->
        <div class="container">
            <div class="row">
                <div class="col-md-12 text-center foot-link">
                    <!-- <a>由嗨课编程云提供技术支持 点击入驻嗨课编程云</a> -->
                </div>
            </div>
        </div>
    </section><!-- /.footer -->
    <!-- <div class="footPage container">
        <div class="footPageDiv">
            <div class="container footer_box">
                <span>电话：400-0088-972</span>
                <span>{{ `合作咨询邮箱：co@${institutionConfig.baseDomainName}` }}</span>
                <span>地址：北京市亦庄开发区经海三路18号盛通股份办公楼1层</span>
                <img src="../assets/code.jpg" alt="">
                <span>&copy;2018-2019 北京极客海码教育科技有限公司</span>
                <span>京ICP备19022229号-1</span>
            </div>
        </div>
        <div>
            <div class="code">
                <img src="../assets/code.jpg" alt="">
            </div>
        </div>
    </div> -->
</template>
<script>
export default {
    computed: {
        themeData() {
            return this.$store.state.themeData;
        }
    },
    data() {
        return {
            introduction: "",
            phone: "",
            mailbox: "",
            address: "",
            realmNameRegNum: "",
            erweima: ""
        }
    },
    created() {
        this.setData();
    },
    methods: {
        setData() {
            if(this.themeData) {
                this.address = this.themeData.address? this.themeData.address : "";
                this.phone = this.themeData.contactPhone? this.themeData.contactPhone : "";
                this.introduction = this.themeData.desc? this.themeData.desc : "";
                this.erweima = this.themeData.erweima? this.themeData.erweima : "";
                this.realmNameRegNum = this.themeData.realmNameRegNum? this.themeData.realmNameRegNum : "";
            }
        }
    }
}
</script>
<style scoped>
.foot-link {
    padding-top: 10px;
}
.foot-link a {
    color: #ddd;
    cursor: pointer;
}
.foot-link a:hover {
    color: #bbb;
}
.color-eee {
    color: #eee;
}
</style>


// WEBPACK FOOTER //
// src/components/foot.vue